export const t10s = {
  label: 'Email',
};
